import {
  createContext,
  useCallback,
  useContext,
  useMemo,
  useState,
} from "react";
import { useMainContext } from "../../../context";
import { useNavigate, useParams } from "react-router-dom";
import { SessionService } from "../../../services/persistService";
import { ROUTES } from "../../../routes";
import { toast } from "react-toastify";

export const ItemPageContext = createContext({});

export const ItemPageProvider = ({ children }) => {
  const [obs, setObs] = useState("");
  const navigate = useNavigate();
  const params = useParams();
  const [modalOpen, setModalOpen] = useState(false);
  const [numOfProduct, setNumOfProduct] = useState(1);
  const {
    product,
    setProduct,
    setOrder,
    setProducts,
    posItem,
    setShowCart,
    fetchData,
    restaurant,
  } = useMainContext();
  const [requiredOptionsList, setRequiredOptionList] = useState([]);
  const [productNumberOfFlavors, setProductNumberOfFlavors] = useState(0);
  const [totalFlavorsSelected, setTotalFlavorsSelected] = useState(0);
  const [formIsValid, setFormIsValid] = useState(false);

  const calcMaxValues = useCallback((product) => {
    let values_max = [];
    if (product) {
      product.requireds.forEach(() => {
        values_max.push(0);
      });
      product.requireds.forEach((required, indexRequired) => {
        required.groupsOptions.forEach((group, indexGroup) => {
          group.options.forEach((option, indexOption) => {
            if (option.selected) {
              if (values_max[indexRequired] < option.price)
                values_max[indexRequired] = option.price;
            }
          });
        });
      });
    }
    return values_max;
  }, []);

  const correctProductPrices = useCallback((product) => {
    const correctProduct = product;
    if (correctProduct) {
      const values_max = calcMaxValues(correctProduct);
      for (let i = 0; i < correctProduct.requireds.length; i++) {
        let flag = false;
        for (
          let j = 0;
          j < correctProduct.requireds[i].groupsOptions.length;
          j++
        ) {
          for (
            let k = 0;
            k < correctProduct.requireds[i].groupsOptions[j].options.length;
            k++
          ) {
            if (
              correctProduct.requireds[i].groupsOptions[j].options[k].selected
            ) {
              if (
                correctProduct.requireds[i].groupsOptions[j].options[k].price <
                values_max[i]
              )
                correctProduct.requireds[i].groupsOptions[j].options[k].price =
                  0;
              else if (
                correctProduct.requireds[i].groupsOptions[j].options[k].price >
                values_max[i]
              )
                correctProduct.requireds[i].groupsOptions[j].options[k].price =
                  0;
              else {
                if (flag)
                  correctProduct.requireds[i].groupsOptions[j].options[
                    k
                  ].price = 0;
                flag = true;
              }
            }
          }
        }
      }
    }
    return correctProduct;
  }, []);

  const clickCheckRequired = (indexRequired, indexGroup, indexOption) => {
    setProduct((atualProduct) => {
      const newProduct = atualProduct;
      if (newProduct) {
        let qnt = 0;
        newProduct.requireds[indexRequired].groupsOptions.forEach((group) => {
          group.options.forEach((option) => {
            if (option.selected === undefined) option.selected = false;
            if (option.selected) qnt++;
          });
        });
        if (
          !(
            !newProduct.requireds[indexRequired].groupsOptions[indexGroup]
              .options[indexOption].selected &&
            newProduct.requireds[indexRequired].numChoose === qnt
          )
        ) {
          newProduct.requireds[indexRequired].groupsOptions[indexGroup].options[
            indexOption
          ].selected =
            !newProduct.requireds[indexRequired].groupsOptions[indexGroup]
              .options[indexOption].selected;
        }
      }

      return { ...newProduct };
    });
  };

  const clickCheckAdditional = useCallback((indexGroup, indexAdditional) => {
    setProduct((atualProduct) => {
      const newProduct = atualProduct;
      if (newProduct) {
        newProduct.groupsAdditionals[indexGroup].additionals[
          indexAdditional
        ].selected =
          !newProduct.groupsAdditionals[indexGroup].additionals[indexAdditional]
            .selected;
      }
      return { ...newProduct };
    });
  }, []);

  const clickGoToCart = useCallback(() => {
    if (!product) return;

    const hasRequiredSelected = validateHasRequiredSelected();

    const restaurantServesAtAddress = SessionService.getItem(
      "restaurantServesAtAddress",
    );

    if (restaurantServesAtAddress === false) {
      return toast.error("O restaurante não atende no seu CEP");
    }

    if (!hasRequiredSelected) {
      return toast.error("Selecione os obrigatórios");
    }

    setOrder((atualOrder) => {
      const newItem = {
        id: null,
        comments: obs,
        product_id: product.id,
        order_id: null,
        size_id: product.size.id,
        qnt: numOfProduct,
        product: correctProductPrices(JSON.parse(JSON.stringify(product))), //adiconar ternario
      };

      setProducts((atualProducts) => {
        const newProducts = JSON.parse(JSON.stringify(atualProducts));
        newProducts.push(product);
        return [...newProducts];
      });

      if (atualOrder) {
        const newItems = atualOrder.items;
        newItems.push(newItem);

        const newOrder = atualOrder;
        newOrder.items = newItems;
        return { ...newOrder };
      } else {
        const newOrder = {};
        newOrder.items = [newItem];
        return { ...newOrder };
      }
    });

    fetchData();
    setModalOpen(false);
    setShowCart(true);

    toast.success("Produto adicionado ao carrinho!");
    navigate(restaurant.id ? ROUTES.RESTAURANT(restaurant.id) : ROUTES.CART, {
      replace: true,
    });
  }, [obs, product, numOfProduct, restaurant]);

  const validateHasRequiredSelected = () => {
    if (product.requireds.length === 0) return true;
    for (let required of product.requireds) {
      for (let groupOption of required.groupsOptions) {
        for (let option of groupOption.options) {
          console.log(option);
          if (option.selected) {
            return true;
          }
        }
      }
    }
    return false;
  };

  const clickGoToPromotionalWithdrawal = useCallback(() => {
    if (product) {
      setOrder((atualOrder) => {
        const newItem = {
          id: null,
          comments: obs,
          product_id: product.id,
          order_id: null,
          size_id: product.size.id,
          qnt: numOfProduct,
          product: correctProductPrices(JSON.parse(JSON.stringify(product))),
        };
        setProducts((atualProducts) => {
          const newProducts = JSON.parse(JSON.stringify(atualProducts));
          newProducts.push(product);
          return [...newProducts];
        });
        if (atualOrder) {
          const newItems = atualOrder.items;
          newItems.push(newItem);

          const newOrder = atualOrder;
          newOrder.items = newItems;
          return { ...newOrder };
        } else {
          const newOrder = {};
          newOrder.items = [newItem];
          return { ...newOrder };
        }
      });
    }
  }, [obs, product, numOfProduct]);

  const addOneNumProduct = useCallback(() => {
    setNumOfProduct((atualNumOfProduct) => {
      return atualNumOfProduct + 1;
    });
  }, []);

  const removeOneNumProduct = useCallback(() => {
    setNumOfProduct((atualNumOfProduct) => {
      return atualNumOfProduct > 1 ? atualNumOfProduct - 1 : atualNumOfProduct;
    });
  }, []);

  const orderSummary = useMemo(() => {
    let total = 0;
    const additionals = [];
    const requireds = [];

    if (product != null) {
      total += product.price;

      product.groupsAdditionals.forEach((group) => {
        group.additionals.forEach((additional) => {
          if (additional.selected) {
            additionals.push({
              name: additional.name,
              price: additional.price,
            });
          }
        });
      });

      if (product.category.price_method === 2) {
        product.requireds.forEach((required) => {
          required.groupsOptions.forEach((group) => {
            if (!group.special_type) {
              group.options.forEach((option) => {
                if (option.selected) {
                  requireds.push({
                    name: option.name,
                    price: option.price * option.quantity,
                  });
                }
              });
            }
          });
        });
      } else {
        product.requireds.forEach((required, indexRequired) => {
          let items = [];

          required.groupsOptions.forEach((group, indexGroup) => {
            group.options.forEach((option, indexOption) => {
              if (option.selected) {
                items.push({
                  name: option.name,
                  price: option.price,
                });
              }
            });
          });

          const maxPrice = Math.max.apply(
            Math,
            items.map(function (o) {
              return o.price;
            }),
          );
          let alreadyAdded = false;

          requireds.push(
            ...items.map((item) => {
              if (item.price === maxPrice && !alreadyAdded) {
                alreadyAdded = true;
                return { name: item.name, price: item.price };
              } else {
                return { name: item.name, price: 0 };
              }
            }),
          );
        });
      }
    }

    total += additionals.reduce((acc, additional) => acc + additional.price, 0);
    total += requireds.reduce((acc, required) => acc + required.price, 0);

    return {
      price: product.price,
      additionals,
      requireds,
      total,
    };
  }, [product]);

  const validateRequireds = useCallback(() => {
    let isValid = true;
    if (!product) return;

    if (product.category.price_method === 2) {
      if (
        totalFlavorsSelected !== 0 &&
        totalFlavorsSelected === productNumberOfFlavors
      ) {
        setFormIsValid(true);
      } else {
        setFormIsValid(false);
      }
    } else {
      for (let i = 0; i < product.requireds.length; i++) {
        const maxNumChoose = product.requireds[i].numChoose;
        let numChoose = 0;
        for (let j = 0; j < product.requireds[i].groupsOptions.length; j++) {
          for (
            let k = 0;
            k < product.requireds[i].groupsOptions[j].options.length;
            k++
          ) {
            if (product.requireds[i].groupsOptions[j].options[k].selected)
              numChoose++;
          }
        }
        if (!(numChoose >= 1 && numChoose <= maxNumChoose)) isValid = false;
      }
      setFormIsValid(true);
    }
  }, [product, totalFlavorsSelected, productNumberOfFlavors]);

  const getRequiredOptionsList = () => {
    let _requiredOptionsList = [];
    const groupsOptions = product?.requireds.map((required) => {
      return required.groupsOptions;
    });

    if (groupsOptions) {
      for (let i = 0; i < groupsOptions?.length; i++) {
        for (let j = 0; j < groupsOptions[i].length; j++) {
          for (let k = 0; k < groupsOptions[i][j].options.length; k++) {
            _requiredOptionsList.push(groupsOptions[i][j].options[k]);
          }
        }
      }
    }
    setRequiredOptionList(_requiredOptionsList);

    if (!product) return;
    for (let i = 0; i < product.requireds.length; i++) {
      if (product.requireds[i].name.toUpperCase().trim() == "SABORES") {
        setProductNumberOfFlavors(product.requireds[i].numChoose);
      }
    }
  };

  const updateRequiredOptionQuantity = useCallback(
    (requiredOptionId, increment) => {
      for (let i = 0; i < requiredOptionsList.length; i++) {
        if (requiredOptionsList[i].id == requiredOptionId) {
          if (increment) {
            if (totalFlavorsSelected >= productNumberOfFlavors) return;
            if (!requiredOptionsList[i].quantity) {
              requiredOptionsList[i].quantity = 1;
            } else {
              requiredOptionsList[i].quantity += 1;
            }
            setTotalFlavorsSelected(totalFlavorsSelected + 1);
          } else {
            if (
              totalFlavorsSelected >= productNumberOfFlavors &&
              requiredOptionsList[i].quantity === 0
            )
              return;

            if (
              totalFlavorsSelected > 0 &&
              requiredOptionsList[i].quantity > 0
            ) {
              setTotalFlavorsSelected(totalFlavorsSelected - 1);
            }

            if (requiredOptionsList[i].quantity > 0)
              requiredOptionsList[i].quantity -= 1;
            updateProduct(requiredOptionId, requiredOptionsList[i].quantity);
          }
        }
      }
    },
    [requiredOptionsList, totalFlavorsSelected, productNumberOfFlavors],
  );

  const updateProduct = (id, quantity) => {
    const groupsOptions = product?.requireds.map((required) => {
      return required.groupsOptions;
    });

    if (groupsOptions) {
      for (let i = 0; i < groupsOptions?.length; i++) {
        for (let j = 0; j < groupsOptions[i].length; j++) {
          for (let k = 0; k < groupsOptions[i][j].options.length; k++) {
            if (groupsOptions[i][j].options[k].id == id) {
              groupsOptions[i][j].options[k].quantity = quantity;
            }
          }
        }
      }
    }
  };

  return (
    <ItemPageContext.Provider
      value={{
        obs,
        setObs,
        params,
        modalOpen,
        setModalOpen,
        numOfProduct,
        setNumOfProduct,
        requiredOptionsList,
        setRequiredOptionList,
        productNumberOfFlavors,
        setProductNumberOfFlavors,
        totalFlavorsSelected,
        setTotalFlavorsSelected,
        formIsValid,
        setFormIsValid,
        setOrder,
        posItem,
        setProducts,
        updateRequiredOptionQuantity,
        clickCheckAdditional,
        orderSummary,
        addOneNumProduct,
        removeOneNumProduct,
        clickCheckRequired,
        getRequiredOptionsList,
        validateRequireds,
        clickGoToPromotionalWithdrawal,
        clickGoToCart,
      }}
    >
      {children}
    </ItemPageContext.Provider>
  );
};

export const useItemPageContext = () => useContext(ItemPageContext);
